module.exports = __webpack_public_path__ + "img/pass_ein.0686763c.png";